import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    padding: [theme.spacing(3), 0],
    [theme.breakpoints.up('mobile')]: {
      padding: [theme.spacing(4), 0],
    },
  },
  avatarBlock: {
    padding: [theme.spacing(3), 0],
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('mobile')]: {
      padding: [0, 0, theme.spacing(4)],
    },
  },
  avatarButtons: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 300,
    flexGrow: 1,
  },
  avatarButton: {
    borderColor: theme.palette.colors.teal,
    [theme.breakpoints.up('mobile')]: {
      width: 194,
    },
  },
  avatar: {
    width: 110,
    height: 110,
    marginRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('mobile')]: {
      width: 96,
      height: 96,
      marginRight: theme.spacing(4),
    },
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 10,
  },
  groups: {
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      marginBottom: theme.spacing(2),
    },
  },
  formGroup: {
    [theme.breakpoints.up('mobile')]: {
      flexGrow: 1,
      flexBasis: 0,
      '&:nth-child(2)': {
        margin: [0, theme.spacing(8)],
      },
    },
  },
  offeringsBlocks: {
    paddingBottom: 22,
  },
  checkboxGroup: {
    maxHeight: 200,
  },
  updatesBlock: {
    padding: [theme.spacing(4), 0],
    borderTop: [1, 'dashed', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      padding: [theme.spacing(7), 0],
    },
  },
  label: {
    fontSize: 12,
    marginBottom: theme.spacing(2),
    color: '#90A4AE',
  },
  radioGroup: {
    paddingTop: theme.spacing(2),
  },
  radioGroupLabel: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: 6,
      maxWidth: 700,
    },
  },
  buttonContainer: {
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  button: {
    marginBottom: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      width: 310,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/useStyles.js